import React from 'react'
import { select } from 'glamor'
import {Helmet} from 'react-helmet'
import Link from 'gatsby-link'

const ListLink = ({ to, selected, children }) =>
  <li css={[
    { display: `inline-block` },
    select(`& + &`, {
      marginLeft: `1rem`,
    })
  ]}>
    <Link
      css={(selected === to) ? {
        color: `#525b8d`,
        textDecoration: `underline`,
      } : {}}
      to={to}
    >
      {children}
    </Link>
  </li>

const Layout = ({ children, location: { pathname } }) =>
	<div css={{ margin: `3rem auto`, maxWidth: 750 }}>
    <Helmet>
      <meta charSet="utf-8" />
      <title>Chi-Wei Clifford-Frith</title>
    </Helmet>
		<header css={{ marginBottom: `3rem` }}>
      <div css={{ padding: `0 0.5rem` }}>
  			<Link to="/">
  				<h3 css={{ display: `inline` }}>
            Chi-Wei <span css={{ color: '#aaa', fontSize: '0.8em' }}>Huang</span> Clifford-Frith
          </h3>
  			</Link>
        <ul css={{ listStyle: `none`, float: `right`, margin: 0 }}>
          <ListLink selected={pathname} to="/">Portfolio</ListLink>
          <ListLink selected={pathname} to="/profile/">Profile</ListLink>
        </ul>
      </div>
      <div css={{ width: `100%`, height: 1, backgroundColor: `black` }}/>
		</header>
		{children()}
	</div>

export default Layout



// WEBPACK FOOTER //
// ./src/layouts/index.js